"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = exports.NumberInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NumberInput = require("./NumberInput.styled");

var _MoreInfoModal = require("../Modal/MoreInfoModal");

var _componentAnalytics = require("../Components/ComponentAnalytics/componentAnalytics");

var _excluded = ["className", "min", "max", "step", "value", "onChange", "title", "moreInfoTitle", "moreInfoHelpText"];

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var NumberInput = function NumberInput(_ref) {
  var className = _ref.className,
      min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      value = _ref.value,
      onChange = _ref.onChange,
      title = _ref.title,
      moreInfoTitle = _ref.moreInfoTitle,
      moreInfoHelpText = _ref.moreInfoHelpText,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  (0, _react.useEffect)(function () {
    (0, _componentAnalytics.trackMe)("NumberInput");
  }, []);

  var _useState = (0, _react.useState)(value),
      currentValue = _useState[0],
      setCurrentValue = _useState[1];

  return /*#__PURE__*/_react.default.createElement(_NumberInput.MainContainer, {
    className: className
  }, /*#__PURE__*/_react.default.createElement("p", null, title), /*#__PURE__*/_react.default.createElement(_NumberInput.NumberInputContainer, null, /*#__PURE__*/_react.default.createElement(_NumberInput.NumberInputContainer.Input, (0, _extends2.default)({}, rest, {
    value: currentValue,
    onChange: function change(e) {
      var targetValue = e.target.value;

      if (targetValue <= max && targetValue >= min || !targetValue) {
        setCurrentValue(targetValue);
        onChange(targetValue.toString());
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_NumberInput.NumberInputContainer.ButtonMinus, {
    onClick: function decrement() {
      if (currentValue >= min + step) {
        var newValue = parseInt("" + currentValue) - step;
        setCurrentValue(newValue);
        onChange(newValue.toString());
      }
    }
  }, "\u2013"), /*#__PURE__*/_react.default.createElement(_NumberInput.NumberInputContainer.ButtonAdd, {
    onClick: function increment() {
      // check for an undefined, NaN or empty string, rather than logical NOT operator, as value could be 0 or -1
      if (currentValue === void 0 || isNaN(currentValue) || "" === currentValue) {
        setCurrentValue(min);
        onChange(min.toString());
      } else if (currentValue <= max - step) {
        var newValue = parseInt("" + currentValue) + step;
        setCurrentValue(newValue);
        onChange(newValue.toString());
      }
    }
  }, "+"), /*#__PURE__*/_react.default.createElement(_MoreInfoModal.MoreInfoModal, {
    title: moreInfoTitle,
    helpText: moreInfoHelpText
  })));
};

exports.NumberInput = NumberInput;
NumberInput.propTypes = {
  className: _propTypes.default.string,
  min: _propTypes.default.number.isRequired,
  max: _propTypes.default.number.isRequired,
  step: _propTypes.default.number,
  value: _propTypes.default.number,
  onChange: _propTypes.default.func.isRequired,
  title: _propTypes.default.string,
  moreInfoTitle: _propTypes.default.string,
  moreInfoHelpText: _propTypes.default.string
};
NumberInput.defaultProps = {
  step: 1,
  min: 1,
  max: 20,
  value: 1
};
var _default = NumberInput;
exports.default = _default;